export default __webpack_public_path__ + "static/288-035158ab65e9744d61cc177ecea814a4.gif";